import { Component, AfterContentInit } from '@angular/core';
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import { Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';

@Component({
  selector: 'ms-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements AfterContentInit {
  title = 'Biochemistry-Lab-Simulator';
  nCurLevel = 0;
  nMaxLevel = 6;

  currentUrl: string = "";

  constructor(private router: Router) {
    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd ) {
        this.currentUrl = event.url.substring(1); // remove "/" from beginning
        this.updateCurLevel(this.currentUrl);
        this.ngAfterContentInit();
      }
    });
  }

  updateCurLevel(curUrl: string) {
    switch (curUrl) {
      case "lab1":
        this.nCurLevel = 1;
        break;
      case "lab2":
        this.nCurLevel = 2;
        break;
      case "lab3":
        this.nCurLevel = 3;
        break;
      case "lab4":
        this.nCurLevel = 4;
        break;
      case "lab5":
        this.nCurLevel = 5;
        break;
      case "lab6":
        this.nCurLevel = 6;
        break;
    }
  }

  ngAfterContentInit() {
      this.updateBackNextBtnStatus();
  }

  updateBackNextBtnStatus() {
    if (this.nCurLevel > 0) {
        (document.getElementById('iBackBtn') as HTMLElement).className = '';
    } else {
      console.log("got here");
        (document.getElementById('iBackBtn') as HTMLElement).className = 'disabled';
    }

    if (this.nCurLevel < this.nMaxLevel) {
        (document.getElementById('iNextBtn') as HTMLElement).className = '';
    } else {
        (document.getElementById('iNextBtn') as HTMLElement).className = 'disabled';
    }
  }

  moveToPrevLevel() {
    if (this.nCurLevel === 1) {
      this.router.navigateByUrl('/');
      this.nCurLevel--;
    }
    else if (this.nCurLevel > 1) {
      this.nCurLevel--;
      this.router.navigateByUrl('/lab' + this.nCurLevel);
    }
    this.updateBackNextBtnStatus();
  }

  moveToNextLevel() {
    if (this.nCurLevel < this.nMaxLevel) {
        this.nCurLevel++;
        this.router.navigateByUrl('/lab' + this.nCurLevel);
    }
    this.updateBackNextBtnStatus();
  }
}
